import { React, useState, useRef, useEffect } from "react";
import { Button, Input } from 'antd-mobile'
import styles from './AddFilter.module.css'

//props.listShell 传入的参数，一个来自states类的列表的包装
export default (props) => {
  if (!props.listShell) return null
  const [_curULPos, setCurULPos] = useState(0)
  const [trig, setTrig] = useState(1)
  const ref_UL = useRef(null)
  const ref_InputTag = useRef(null)

  useEffect(() => { //设置滚动条回滚
    if (ref_UL.current) {
      ref_UL.current.scrollTop = _curULPos
    }
  }, [trig])

  const onListItemClicked = (key) => {
    console.log('按了按钮！', key)
    if (ref_UL.current) {
      setCurULPos(ref_UL.current.scrollTop)
    }
    props.listShell.listAdd[key].selected = !props.listShell.listAdd[key].selected
    setTrig(trig + 1)
  }

  const RenderSingleListItem = (props) => {

    return (<div className={styles.tagListItem}>
      <Button style={{ marginBottom: '2px', marginRight: '5px' }} block shape="rounded" color="success"
        fill={props.tag.selected ? "solid" : "outline"}
        onClick={() => { onListItemClicked(props.tag.key) }}>{props.tag.name}</Button>
    </div>)
  }
  const onSelectAddNewTag = () => {
    var value = ref_InputTag.current?.nativeElement.value
    console.log('form = ', ref_InputTag.current?.nativeElement.value)
    if (value === null || value === '') return
    var len = props.listShell.listAdd.length
    //检查是否重复,如果重复则选上,然后return
    for (let index = 0; index < len; index++) {
      if (props.listShell.listAdd[index].name === value) {
        props.listShell.listAdd[index].selected = true
        if (ref_UL.current) {
          setCurULPos(ref_UL.current.scrollTop)
        }
        setTrig(trig + 1)
        return
      }
    }
    //没有重复,添加进选择list和添加list
    props.listShell.listAdd.push({ key: len, name: value, selected: true })
    // props.listShell.listNew.push(value)
    if (ref_UL.current) {
      setCurULPos(ref_UL.current.scrollTop)
    }
    setTrig(trig + 1)
  }

  const RenderList = () => {
    console.log('渲染List，当前的数据是', props.listShell.listAdd)
    return (<div className={styles.fltContainer}>
      <ul ref={ref_UL} trig={trig} className={styles.fltList}>
        {props.listShell.listAdd.map((tag) => {
          return (
            <li key={tag.key}><RenderSingleListItem tag={tag} /></li>
          )
        })}
      </ul>
      <div style={{ width: '10%' }}></div>
      <div className={styles.fltBtn}>
        <Input ref={ref_InputTag} placeholder="添加一个"></Input>
        <div style={{ height: '20px' }} />
        <Button block onClick={() => onSelectAddNewTag()}>添加</Button>
      </div>
    </div>)
  }

  return (<RenderList />)
}